import React from 'react';
import { observer } from 'mobx-react';

interface IRadioGroup {
  label?: string;
  labelId: string;
  items: IRadioItem[];
}

interface IRadioItem {
  label?: string;
  id: string;
  name: string;
  className?: string;
  onChange: (event: {}) => void;
  disabled?: boolean;
  checked: boolean;
}

const RadioGroupComponent = (props: IRadioGroup) => {
  return (
    <div>
      <fieldset className="usa-fieldset">
        {props.label ? <label className="usa-label" id={props.labelId}>
          {props.label}
        </label> : null}
        {props.items.map((el, i) => (
          <div className="usa-radio" key={"group" + i}>
            <input
              className={'usa-radio__input ' + el.className}
              id={el.id}
              key={el.id + i}
              data-testid={'the-RadioGroup-' + i}
              aria-describedby={props.labelId}
              type="radio"
              name={el.name}
              checked={el.checked}
              onChange={el.onChange}
              disabled={el.disabled}
            />
            <label className="usa-radio__label" htmlFor={el.id} key={"label" + el.id + i}>
              {el.label}
            </label>
          </div>
        ))}
      </fieldset>
    </div>
  );
};

export const RadioGroup = observer(RadioGroupComponent);
